import { languageMap } from ".."

languageMap.makefile = {
	comments: {
		line: "#",
	},
}
